import { Type } from 'class-transformer';
import { PublishInfoRawDto } from './publish-info-raw-dto';
import { ContactPublishInfoRawDto } from './contact-publish-info-raw-dto';

export class PropertyPublishInfoRawDto {
  @Type(() => PublishInfoRawDto)
  ownerName: PublishInfoRawDto;

  @Type(() => PublishInfoRawDto)
  mailingAddress: PublishInfoRawDto;

  @Type(() => ContactPublishInfoRawDto)
  contacts: Array<ContactPublishInfoRawDto>;

  status: string;
  message: string;
}
